import React from 'react'
import fl2 from '../bookIMG/nyameMeraku/nm2.jpg'
import fl3 from '../bookIMG/nyameMeraku/nm3.jpg'
import wag from '../bookIMG/nyameMeraku/nm4.jpg'
import fl4 from '../bookIMG/nyameMeraku/nm6.jpg'
import {TbArrowBackUpDouble} from 'react-icons/tb'
import { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {PiWifiHighBold} from 'react-icons/pi'
import {PiMonitorThin} from 'react-icons/pi'
import {TbPointFilled} from 'react-icons/tb'
import {FaMapLocationDot} from 'react-icons/fa6'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {FaArrowAltCircleLeft} from 'react-icons/fa'
import NyameMap from './NyameMap'
import '../Loade.css'
const Nyame = () => {
  const notify=()=>{
    toast.info('0245396040', {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      });
  }
  const [loading, setloading]=useState(true)
  useEffect(()=>{
    setTimeout(() => {
      setloading(false)
    }, 2000);
  })
    const [image,setimage]=useState(fl2)
  function changeImage(e){
    setimage(fl2)
    e.preventDefault()
  }
  function changeImage1(e){
    setimage(fl4)
    e.preventDefault()
  }
  function changeImage2(e){
    setimage(fl3)
    e.preventDefault()
  }
  function changeImage3(e){
    setimage(wag)
    e.preventDefault()
  }
  const nav=useNavigate()
  function back(){
      nav(-1)
  }
  return (
    <div>
      {
            loading==true? <div className=' flex justify-center items-center bg-black absolute h-full w-full'>
          
            <h4 class="preloader flex justify-center items-center">
              <h4 class="preloader__ring">
                <h4 class="preloader__sector">P</h4>
                <h4 class="preloader__sector">b</h4>
                <h4 class="preloader__sector">o</h4>
                <h4 class="preloader__sector">o</h4>
                <h4 class="preloader__sector">k</h4>
                <h4 class="preloader__sector">i</h4>
                <h4 class="preloader__sector">n</h4>
                <h4 class="preloader__sector">g</h4>
                <h4 class="preloader__sector">.</h4>
                <h4 class="preloader__sector">.</h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
              </h4>
              <h4 class="preloader__ring">
                <h4 class="preloader__sector">P</h4>
                <h4 class="preloader__sector">b</h4>
                <h4 class="preloader__sector">o</h4>
                <h4 class="preloader__sector">o</h4>
                <h4 class="preloader__sector">k</h4>
                <h4 class="preloader__sector">i</h4>
                <h4 class="preloader__sector">n</h4>
                <h4 class="preloader__sector">g</h4>
                <h4 class="preloader__sector">.</h4>
                <h4 class="preloader__sector">.</h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
                <h4 class="preloader__sector"></h4>
              </h4>
            </h4>
                     </div> :<div>
      <FaArrowAltCircleLeft className=' sm:w-48 h-80 fixed text-violet-500'  style={{width:'5%',height:'7%',marginTop:'5px', cursor:'pointer',position:'fixed',marginTop:'-5px',top:'30px'}} onClick={back} />
      <div className='grid lg:grid-cols-2 gap-10 py-10 px-5'>
      <img src={image} className=' md:my-14 rounded-md shadow-xl lg:h-3/5' style={{width:'100%'}} />
      <div className=' hidden md:block'>
      <h1 className=' text-xl text-slate-900 text-center uppercase' style={{fontSize:'70px',fontStyle:'oblique',fontFamily:'initial'}} >Nyame Mireku</h1>
   <h1 className=' py-0 my-8 opacity-80 shadow-md'  style={{height:'2px',background:'black',top:'50%'}}> </h1>
  <h3 className=' -my-5 text-opacity-95 opacity-90' style={{fontSize:'20px'}}>A hostel in KNUST with DSTV,Wi-Fi and plant</h3>
        <h1 className=' my-10 text-4xl text-black inline-block'>Kumasi<FaMapLocationDot style={{color:'rgb(139, 139, 255)',display:'inline-block', marginLeft:'8px', marginBottom:'10px'}} />
        <div className=' text-lg my-2 opacity-80'>KNUST,Ghana</div>
        </h1>
      <NyameMap />
      <div className=' inline-block my-2 mx-5 text-lg font-bold'><PiWifiHighBold style={{color:'blue', width:'50px',height:'30px', paddingRight:'20px'}} />  WIFI </div>
        <span className='inline-block my-2 mx-4 text-lg font-bold'><PiMonitorThin style={{color:'blue', width:'50px',height:'30px', paddingRight:'6px'}} /> DS TV</span>
        <div>
        <h1 className=' font-mono text-3xl text-red-700 mx-4' style={{marginTop:'35px'}}>Hostel Rules</h1>
        <li className='inline-block my-2 mx-4 font-semibold'><TbPointFilled className=' inline-block' /> No pet</li>
        <li className='inline-block my-2 mx-4 font-semibold '><TbPointFilled className=' inline-block' /> No non-student</li>
      </div>
      <h1 className=' py-0 my-8 opacity-80 shadow-md'  style={{height:'2px',background:'black',top:'0%'}}> </h1>
      <h1 className=' text-2xl font-serif -my-2 inline-block'>Available</h1>
      <a  href="tel:+233245396040" className=' bg-blue-700 w-36 cursor-pointer shadow-sm h-14 rounded-lg inline-block mx-5 text-white font-mon'> <span className=' font-thin mx-2' style={{fontSize:'20px'}}>BOOK</span><span className=' text-black' style={{fontSize:'30px',marginTop:'300px'}}>|</span><span className=' text-white font-bold text-2xl'> Ghc</span></a>
      <button className=' bg-gray-600 w-36 h-14 rounded-lg inline-block mx-1 py-2'  onClick={notify}> <span className=' text-white font-mono text-lg'>View Number</span></button>
      <ToastContainer />
      </div>
        <span className=' grid grid-cols-4 gap-2 mx-0 px-0 cursor-pointer lg:-my-96'><img src={fl2} className=' rounded-md shadow-md h-32' style={{width:'100%'}} onClick={changeImage} />
        <img src={fl4} className=' rounded-md shadow-md h-32' style={{width:'100%'}} onClick={changeImage1} />
        <img src={fl3} className=' rounded-md shadow-md h-32' style={{width:'100%'}} onClick={changeImage2} />
        <img src={wag} className=' rounded-md shadow-md h-32' style={{width:'100%'}}  onClick={changeImage3}/>
        </span> 
        <div className='grid md:hidden my-0'>
        <h1 className=' text-xl text-slate-900 text-center uppercase' style={{fontSize:'40px',fontStyle:'oblique',fontFamily:'initial'}} >Nyame Mireku</h1>
   <h1 className=' py-0 my-8 opacity-80 shadow-md'  style={{height:'2px',background:'black',top:'50%'}}> </h1>
  <h3 className=' -my-5 text-opacity-95 opacity-90' style={{fontSize:'20px'}}>A hostel in KNUST with DSTV,Wi-Fi</h3>
        <h1 className=' my-10 text-4xl text-black inline-block'>Kumasi<FaMapLocationDot style={{color:'rgb(139, 139, 255)',display:'inline-block', marginLeft:'8px', marginBottom:'10px'}} />
        <div className=' text-lg my-2 opacity-80'>KNUST,Ghana</div>
        </h1>
        <NyameMap />
        <div className=' my-2'>
        <div className=' inline-block mx-4  text-lg font-bold'><PiWifiHighBold style={{color:'blue', width:'50px',height:'30px', paddingRight:'20px'}} />  WIFI </div>
        <span className='inline-block  mx-4 text-lg font-bold'><PiMonitorThin style={{color:'blue', width:'50px',height:'30px', paddingRight:'6px'}} /> DS TV</span>
        </div>
        <div>
        <h1 className=' font-mono text-3xl text-red-700 mx-4' style={{marginTop:'35px'}}>Hostel Rules</h1>
        <li className='inline-block my-2 mx-4 font-semibold'><TbPointFilled className=' inline-block' /> No pet</li>
        <li className='inline-block my-2 mx-4 font-semibold '><TbPointFilled className=' inline-block' /> No non-student</li>
      </div>
      
      <h1 className=' py-0 my-3 opacity-80 shadow-md'  style={{height:'2px',background:'black',top:'0%'}}> </h1>
      <h1 className=' text-4xl font-serif mx-2'>Available</h1>
      <div>
      <a  href="tel:+233245396040" className=' bg-blue-700 w-36 cursor-pointer shadow-sm h-14 rounded-lg inline-block text-white font-mon'> <span className=' font-thin mx-2' style={{fontSize:'20px'}}>BOOK</span><span className=' text-black' style={{fontSize:'30px',marginTop:'300px'}}>|</span><span className=' text-white font-bold text-2xl'> Ghc</span></a>
      <button  className=' bg-gray-600 w-36 h-14 rounded-lg inline-block mx-4 my-5'  onClick={notify}> <span className=' text-white font-mono text-lg'>View Number</span></button>
      <ToastContainer />
      </div>
        </div>
      </div>
      </div>
      }
    
    </div>
  )
}

export default Nyame
